import { batch, useSignal } from "@preact/signals-react"
import { useCallback, useEffect } from "react"
import { isReportMultipleModalLoading, reportListMultipleData, setReportData } from "Pages/ReportsAlerts/Reports/@signals"
import { postSubmit } from "@ui-seeker/utils"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"
import { useToast } from "@hooks"

export default function useReportMultipleModalMultipleEdit(key = "values") {
	const data = useSignal(reportListMultipleData.peek()[key])
	const { showToast } = useToast()
	const { backendUrl } = useReportBackendApiPath()

	const setData = newValue => batch(() => {
		data.value = newValue
		reportListMultipleData.value = { ...reportListMultipleData.value, values: newValue }
	})

	const setFrequency = value => {
		data.value = value
		reportListMultipleData.value = { ...reportListMultipleData.value, [key]: value }
	}

	const submitData = useCallback(() => {
		postSubmit(`${backendUrl}/${isReportMultipleModalLoading.value}-multi`, reportListMultipleData.value)
			.then(res => {
				res.map(e => setReportData(e))
				reportListMultipleData.value = { values: [], key: '', idReport: [], reportsInfo: [] }
				showToast.success("Successfully updated report")
				isReportMultipleModalLoading.value = null
			})
			.catch(() => {
				reportListMultipleData.value = { values: [], key: '', idReport: [], reportsInfo: [] }
				showToast.error("Error updating report")
				isReportMultipleModalLoading.value = null
			})
	}, [data.value])

	useEffect(() => {
		if (!!isReportMultipleModalLoading.value && (Array.isArray(data.value) ? !!data.value.length : !!data.value)) submitData()
	}, [isReportMultipleModalLoading.value])

	return {
		data: data.value,
		setFrequency,
		setData
	}
}